/// <amd-module name="Reporting/Visuals/VisualMessages/UnconfiguredMessage" />
import * as React from "react";
import * as Resources from "Reporting/Visuals/Resources";
import { format } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";
import { KeyCode } from "VSSUI/Util";
import { Size, VisualMessageBase } from "./VisualMessageBase";

export interface NoDataProps {
    visualTitle: string;
    size: Size;
    renderSmallImage?: boolean;
    onClick?: (event: React.SyntheticEvent<any> | React.SyntheticEvent<any>) => void;
}

/** Used for Rendering "Unconfigured" Experiences for Widgets. */
export class UnconfiguredMessage extends VssComponent<NoDataProps, {}> {
    public render(): JSX.Element {
        const imageLocation = `ms.vss-reporting/reporting-visuals-common/images/unconfigured-large.png`;
        return (
            <div className={"unconfigured-message-container"} tabIndex={0} onClick={this.props.onClick} onKeyDown={this.handleKeyDown} role="button" aria-label={format("{0}{1}", this.props.visualTitle, Resources.Unconfigured_Message)}>
                <VisualMessageBase
                    visualTitle={this.props.visualTitle}
                    messageContent={format(Resources.Unconfigured_Message)}
                    size={this.props.size}
                    imagePath={imageLocation}
                    renderSmallImage={this.props.renderSmallImage}
                    altText={Resources.UnconfiguredImage_AltText}
                />
            </div>
        );
    }

    private handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.keyCode === KeyCode.enter && this.props.onClick) {
            this.props.onClick(event);
        }
    };
}
